import { useCallback, useEffect, useRef, useState } from "react";

import {
    faArrowCircleDown,
    faBarcode,
    faCheck,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { FormProvider, useForm } from "react-hook-form";
import {
    IParcelaBoletos,
    IParcelas,
} from "../../../Interfaces/Cobranca/ParcelasAbertas/ParcelasAbertas";
import { ListarParcelasBoletosController } from "../../../Controllers/Cobranca/ParcelasAbertas/ParcelasAbertasController";

import "moment/locale/pt-br";
import { formatMoneyReais } from "../../../Tools/FormatTools";
import {
    GerarBoletoController,
    GerarBoletoIntegralController,
    GerarBoletoViaContaController,
} from "../../../Controllers/Cobranca/Boleto/BoletoController";

import { useHistoricoContext } from "../../../Context/Historico";

import SpinnerUAU from "../../Loding/SpinnerUAU";
import { useUserInfor } from "../../../Context/User";
import { DescontoAlcada } from "../DescontoAlcada";
import { Modal } from "react-bootstrap";

import "./styles.css";
import { MoneyReaisFieldMask } from "../../../Validations/InputMasks";
import EnviarBoletoPorEmail from "./EnviarBoletoPorEmail";
import IndicadoresGerarBoleto from "./IndicadoresGerarBoleto";
import TableParcelasBoletos from "./TableParcelasBoletos";
import BaixarBoletosSelecioados from "./BaixarBoletosSelecionados";
import { useClientePage } from "../../../Context/ClientePage";
import useAsyncCallback from "../../../hooks/useAsyncCallback";
import DescontoHonorarios from "../DescontoHonorarios";

interface IFormDataProps {
    DataCalculo: string;
    Desconto: number;
    AgruparBoleto: boolean;
    AntecipacaoParcela: boolean;
    RETIRAR_JUROS: boolean;
    RETIRAR_MULTAS: boolean;
    FL_ACRESCENTAR_RESIDUOS: boolean;
    parcelas: {
        [NumParc_Prc: number]: {
            VL_PARCELA_DESEJADO: number;
        };
    };
}

interface IGerarBoletoModalProps {
    parcelasRequest: IParcelas;
    ID_CASO?: number;
    ID_CONTA: number;
    idTipoCaso?: number;

    unidade: string;
    empreendimento: string;
    idParcela?: number;
}

export default function GerarBoletoModal(props: IGerarBoletoModalProps) {
    //#region Hooks
    const { ReloadHistorico } = useHistoricoContext();
    const { idCaso: idCasoClientePage, setIdCaso: setIdCasoClientePage } =
        useClientePage();
    const { OrgInfor } = useUserInfor();

    const [bloqueioHonorario, setBloqueioHonorario] = useState(true);
    const [bloqueioDescontoAlcada, setBloqueioDescontoAlcada] = useState(false);

    const [parcelasReq, setParcelasReq] = useState({
        ...props.parcelasRequest,
        DT_CALCULO: new Date().toISOString().substring(0, 10),
    });

    const [lstParcelasBoletos, setLstParcelasBoletos] = useState<
        Array<IParcelaBoletos>
    >([]);
    const [lstParcelasBoletosHonorarioRequest, setLstParcelasBoletosRequest] =
        useState<Array<IParcelaBoletos>>([]);

    const [desconto, setDesconto] = useState({
        MULTA: 0,
        JUROS: 0,
    });
    const [honorario, setHonorario] = useState(0);

    const [loading, setLoading] = useState(true);
    const [tableLoading, setTableLoading] = useState(false);
    const [gerando, setGerando] = useState(false);

    const [gerandoPix, setGerandoPix] = useState(false);

    const [alertText, setAlertText] = useState("");
    const [porcentagemJuros, setPorcentagemJuros] = useState(0);
    const [porcentagemMulta, setPorcentagemMulta] = useState(0);
    const [porcentagemHonorario, setPorcentagemHonorario] = useState(0);
    const porcentagemHonorarioSaved = useRef<number>(0);
    const [bloquearBaixarBoleto, setBloquearBaixarBoleto] = useState(false);

    const { Config } = useUserInfor();
    const [indicadores, setIndicadores] = useState({
        TOTAL: 0,
        SELECIONADO: 0,
        NR_SELECIONADO: 0,
    });

    // esse shouldUnregister: false é necessário para eveitar o
    // travamento de tela quando a tebela é desmontada ( primeiro
    // era feito unregister, isso que travava a interface )
    const form = useForm<IFormDataProps>({
        shouldUnregister: false,
    });
    const { RETIRAR_JUROS, RETIRAR_MULTAS } = form.watch([
        "RETIRAR_MULTAS",
        "RETIRAR_JUROS",
    ]);

    const [descontoBruto, setDescontoBruto] = useState(0);

    const showResiduo =
        Config.ConfigCobrancaDTO.FL_ACRESCENTAR_RESIDUAL_GERAR_BOLETO;
    const colClasses = {
        input: `col-12 col-lg-${showResiduo ? "5" : "3"}`,
        switches: `col-12 col-lg-${showResiduo ? "6" : "3"}`,
    };

    const siengeMode = OrgInfor.COD_ERP_INTEGRACAO === "SIENGE";
    const totvsMode = OrgInfor.COD_ERP_INTEGRACAO === "TOTVS";
    const informakonMode = OrgInfor.COD_ERP_INTEGRACAO === "INFORMAKON";
    const eSolutionMode =
        OrgInfor.COD_ERP_INTEGRACAO === "ESOLUTION" ||
        OrgInfor.COD_ERP_INTEGRACAO === "ESOLUTION_LIVA";
    //#endregion

    const updateParcelasCallback = useCallback(updateParcelas, []);
    useEffect(() => {
        updateParcelasCallback(parcelasReq);
    }, [parcelasReq, updateParcelasCallback]);

    const { execute: gerarBoletoIntegral } = useAsyncCallback(
        GerarBoletoIntegralController
    );

    const BloquearGerarBoleto = useCallback(() => {
        if (
            lstParcelasBoletosHonorarioRequest.some(
                (parcelasMarcadas) => parcelasMarcadas.Boleto?.BoletoBase64
            )
        ) {
            return setBloquearBaixarBoleto(true);
        } else {
            return setBloquearBaixarBoleto(false);
        }
    }, [lstParcelasBoletosHonorarioRequest]);

    useEffect(() => {
        setDesconto({
            JUROS: RETIRAR_JUROS
                ? lstParcelasBoletosHonorarioRequest.reduce(
                      (sum, parcela) => sum + parcela.vlrJurosAtraso,
                      0
                  )
                : 0,
            MULTA: RETIRAR_MULTAS
                ? lstParcelasBoletosHonorarioRequest.reduce(
                      (sum, parcela) => sum + parcela.ValorMulta,
                      0
                  )
                : 0,
        });

        if (RETIRAR_JUROS || RETIRAR_MULTAS) setDescontoBruto(0);
    }, [RETIRAR_JUROS, RETIRAR_MULTAS, lstParcelasBoletosHonorarioRequest]);

    useEffect(() => {
        BloquearGerarBoleto();
        setIndicadores((indicadores) => ({
            ...indicadores,
            SELECIONADO: lstParcelasBoletosHonorarioRequest.reduce(
                (sum, p) => sum + p.ValorReaj,
                0
            ),
            NR_SELECIONADO: lstParcelasBoletosHonorarioRequest.length,
        }));
    }, [lstParcelasBoletosHonorarioRequest, BloquearGerarBoleto]);

    function updateParcelas(parcelasRequest: IParcelas) {
        setTableLoading(true);
        ListarParcelasBoletosController(parcelasRequest).then((res) => {
            setLoading(false);
            setTableLoading(false);

            const parcelas = res.map((parcela) => ({
                ...parcela,
                ID: `${parcela.NumParcGer_Prc}-${parcela.Boleto?.SeuNum_Bol}`,
            }));
            setLstParcelasBoletos(parcelas);
            setLstParcelasBoletosRequest((lstParcelasMarcadas) => {
                lstParcelasMarcadas.forEach((marcada) => {
                    const parcelaMarcada = parcelas.find(
                        (p) => p.NumParcGer_Prc === marcada.NumParcGer_Prc
                    );
                    if (parcelaMarcada) parcelaMarcada.FL_MARC = true;
                });
                return parcelas.filter((parc) => parc.FL_MARC);
            });
        });
    }

    function handleGerarBoletoFormSubmit(formData: IFormDataProps, e: any) {
        const idCaso = props.ID_CASO ?? idCasoClientePage;
        const req = {
            ID_CASO: 0,
            FL_JUROS_SIMPLES: false,
            FL_MULTA_SIMPLES: false,
            VL_DESCONTO_MULTA: desconto.MULTA,
            VL_DESCONTO_JUROS: desconto.JUROS,
            FL_ANTECIPAR: formData.AntecipacaoParcela,
            FL_AGRUPAR_PARCELAS: formData.AgruparBoleto,
            FL_ACRESCENTAR_RESIDUOS: formData.FL_ACRESCENTAR_RESIDUOS,
            DT_CALCULO: formData.DataCalculo,
            LST_PARCELAS: lstParcelasBoletosHonorarioRequest,
            VL_DESCONTO_BRUTO: descontoBruto,
        };

        let promise: Promise<any> | undefined;
        setAlertText("");
        if (totvsMode) {
            if (e.nativeEvent.submitter.name === "gerarPix") {
                setGerandoPix(true);
            } else {
                setGerando(true);
            }

            promise = gerarBoletoIntegral({
                intCODCOLIGADA: props.parcelasRequest.NR_EMPRESA,
                PIX_BOLETO: e.nativeEvent.submitter.name === "gerarPix" ? 1 : 0,
                dataDATAVENCIMENTO: parcelasReq.DT_CALCULO,
                parcelas: lstParcelasBoletosHonorarioRequest.map(
                    (parcelas) => ({
                        ID_PARCELA: parcelas.NumParc_Prc,
                        VL_PARCELA: parcelas.ValorReaj,
                        VL_PARCELA_DESEJADO:
                            formData.parcelas[parcelas.NumParc_Prc]
                                .VL_PARCELA_DESEJADO ?? parcelas.ValorReaj,
                        PERCENTUAL_DESCONTO_JUROS: porcentagemJuros,
                        PERCENTUAL_DESCONTO_MULTA: porcentagemMulta,
                        VL_MULTA_ATRASO: parcelas.ValorMulta,
                        VL_JUROS_ATRASO: parcelas.vlrJurosAtraso,
                        PERCENTUAL_HONORARIO: porcentagemHonorario,
                        DT_VENCIMENTO: parcelas.Data_Prc,
                    })
                ),
            });
        } else {
            if (idCaso) {
                req.ID_CASO = idCaso;
                setGerando(true);
                promise = GerarBoletoController(req);
            } else if (props.idTipoCaso) {
                setGerando(true);
                promise = GerarBoletoViaContaController(
                    {
                        ...req,
                        ID_CHAVE_ERP: `${props.parcelasRequest.NR_EMPRESA}_${props.parcelasRequest.DS_OBRA}_${props.parcelasRequest.NR_VENDA}`,
                    },
                    props.ID_CONTA,
                    props.idTipoCaso
                ).then((res) => {
                    setIdCasoClientePage(res.ID_CASO);
                });
            }
        }

        if (promise) {
            const plural = req.LST_PARCELAS.length > 1;
            promise
                .then(() => {
                    updateParcelas(parcelasReq);
                    setAlertText(
                        `Boleto${plural ? "s" : ""} gerado${
                            plural ? "s" : ""
                        } com sucesso!`
                    );
                })
                .finally(() => {
                    setGerando(false);
                    setGerandoPix(false);
                })
                .then(() => ReloadHistorico?.());
        }
    }

    return (
        <>
            <Modal.Body>
                <div>
                    {!loading ? (
                        <div className="col-12">
                            {!eSolutionMode && (
                                <EnviarBoletoPorEmail
                                    ID_CONTA={props.ID_CONTA}
                                    ID_CASO={props.ID_CASO}
                                    lstParcelasBoletosRequest={
                                        lstParcelasBoletosHonorarioRequest
                                    }
                                    setLstParcelasBoletosRequest={
                                        setLstParcelasBoletosRequest
                                    }
                                    idTipoCaso={props.idTipoCaso}
                                    parcelasRequest={props.parcelasRequest}
                                    setAlertText={setAlertText}
                                    lstParcelasMarcadas={
                                        lstParcelasBoletosHonorarioRequest
                                    }
                                />
                            )}

                            <FormProvider {...form}>
                                {!eSolutionMode && (
                                    <>
                                        {!siengeMode && (
                                            <form
                                                onSubmit={form.handleSubmit(
                                                    handleGerarBoletoFormSubmit
                                                )}
                                                action="formGerarPix"
                                                id="formGerarBoletos"
                                                className="w-100 align-itens-center p-3"
                                            >
                                                <div className="row mb-3 d-flex flex-wrap align-items-end">
                                                    <div
                                                        className={`${colClasses.input} p-1`}
                                                    >
                                                        <label>
                                                            {" "}
                                                            Data de Cálculo
                                                        </label>
                                                        <input
                                                            type="date"
                                                            name="DataCalculo"
                                                            className={`form-control px-0 p-2 placeholder-dark-75 ${
                                                                form.formState
                                                                    .errors
                                                                    .DataCalculo &&
                                                                "is-invalid"
                                                            }`}
                                                            ref={form.register({
                                                                required:
                                                                    "Data de Cálculo obrigatória",
                                                            })}
                                                            defaultValue={
                                                                parcelasReq.DT_CALCULO
                                                            }
                                                            onBlur={(e) => {
                                                                if (
                                                                    parcelasReq.DT_CALCULO !==
                                                                    e.target
                                                                        .value
                                                                ) {
                                                                    setParcelasReq(
                                                                        {
                                                                            ...parcelasReq,
                                                                            DT_CALCULO:
                                                                                e
                                                                                    .target
                                                                                    .value,
                                                                        }
                                                                    );
                                                                }
                                                            }}
                                                        />
                                                    </div>
                                                    {!Config.ConfigCobrancaDTO
                                                        .FL_ALCADAS_DESCONTO &&
                                                        !informakonMode && (
                                                            <div
                                                                className={`${colClasses.input} p-1`}
                                                            >
                                                                <label>
                                                                    Desconto
                                                                </label>
                                                                <input
                                                                    ref={form.register(
                                                                        {
                                                                            setValueAs:
                                                                                (
                                                                                    v
                                                                                ) =>
                                                                                    Number(
                                                                                        MoneyReaisFieldMask.unMask(
                                                                                            v
                                                                                        )
                                                                                    ),
                                                                        }
                                                                    )}
                                                                    name="Desconto"
                                                                    disabled={
                                                                        RETIRAR_JUROS ||
                                                                        RETIRAR_MULTAS
                                                                    }
                                                                    min={0}
                                                                    max={
                                                                        indicadores.SELECIONADO
                                                                    }
                                                                    value={formatMoneyReais(
                                                                        descontoBruto
                                                                    )}
                                                                    onChange={(
                                                                        e
                                                                    ) => {
                                                                        MoneyReaisFieldMask(
                                                                            e
                                                                        );
                                                                        setDescontoBruto(
                                                                            Number(
                                                                                MoneyReaisFieldMask.unMask(
                                                                                    e
                                                                                        .target
                                                                                        .value
                                                                                )
                                                                            )
                                                                        );
                                                                    }}
                                                                    className={`form-control px-0 p-2 mr-5 placeholder-dark-75 ${
                                                                        form
                                                                            .formState
                                                                            .errors
                                                                            .Desconto &&
                                                                        "is-invalid"
                                                                    }`}
                                                                />
                                                            </div>
                                                        )}

                                                    {showResiduo && (
                                                        <div className="col-12 col-lg-2 p-1">
                                                            <div>
                                                                <div className="d-flex align-items-center justify-content-center text-center">
                                                                    <span>
                                                                        Acrescentar
                                                                        Resíduo
                                                                    </span>
                                                                </div>
                                                                <span
                                                                    className="switch switch-outline switch-sm switch-icon switch-success d-flex justify-content-center align-items-center mt-4"
                                                                    data-toggle="tooltip"
                                                                >
                                                                    <label>
                                                                        <input
                                                                            name="FL_ACRESCENTAR_RESIDUOS"
                                                                            type="checkbox"
                                                                            ref={form.register()}
                                                                        />
                                                                        <span></span>
                                                                    </label>
                                                                </span>
                                                            </div>
                                                        </div>
                                                    )}

                                                    {!totvsMode && (
                                                        <div
                                                            className={`${colClasses.switches} p-1 d-flex justify-content-around`}
                                                        >
                                                            <div className="text-center">
                                                                <div className="d-flex align-items-center justify-content-center">
                                                                    <span>
                                                                        Agrupar
                                                                        Boletos
                                                                    </span>
                                                                </div>
                                                                <span
                                                                    className="switch switch-outline switch-sm switch-icon switch-success d-flex justify-content-center align-items-center mt-4"
                                                                    data-toggle="tooltip"
                                                                >
                                                                    <label>
                                                                        <input
                                                                            name="AgruparBoleto"
                                                                            type="checkbox"
                                                                            ref={form.register()}
                                                                        />
                                                                        <span></span>
                                                                    </label>
                                                                </span>
                                                            </div>
                                                            <div className="text-center">
                                                                <div className="d-flex align-items-center justify-content-center">
                                                                    <span>
                                                                        Antecip.
                                                                        parcelas
                                                                    </span>
                                                                </div>
                                                                <span
                                                                    className="switch switch-outline switch-sm switch-icon switch-success d-flex justify-content-center align-items-center mt-4"
                                                                    data-toggle="tooltip"
                                                                >
                                                                    <label>
                                                                        <input
                                                                            name="AntecipacaoParcela"
                                                                            type="checkbox"
                                                                            disabled={
                                                                                Config
                                                                                    .ConfigCobrancaDTO
                                                                                    .FL_ANTECIPACAO_PARCELAS_BOLETO ===
                                                                                false
                                                                            }
                                                                            ref={form.register()}
                                                                            onChange={(
                                                                                e
                                                                            ) => {
                                                                                setParcelasReq(
                                                                                    {
                                                                                        ...parcelasReq,
                                                                                        FL_ANTECIPACAO:
                                                                                            e
                                                                                                .target
                                                                                                .checked,
                                                                                    }
                                                                                );
                                                                            }}
                                                                        />
                                                                        <span></span>
                                                                    </label>
                                                                </span>
                                                                {Config
                                                                    .ConfigCobrancaDTO
                                                                    .FL_ANTECIPACAO_PARCELAS_BOLETO ===
                                                                false ? (
                                                                    <span className="text-danger">
                                                                        A
                                                                        antecipação
                                                                        está
                                                                        desabilitada
                                                                        nas
                                                                        configurações
                                                                        gerais
                                                                    </span>
                                                                ) : null}
                                                            </div>
                                                        </div>
                                                    )}

                                                    {!Config.ConfigCobrancaDTO
                                                        .FL_ALCADAS_DESCONTO ? (
                                                        <div
                                                            className={`${colClasses.switches} p-1 d-flex justify-content-around`}
                                                        >
                                                            <div className="">
                                                                <div className="d-flex align-items-center justify-content-center">
                                                                    <span>
                                                                        Retirar
                                                                        Juros
                                                                    </span>
                                                                </div>
                                                                <span
                                                                    className="switch switch-outline switch-sm switch-icon switch-success d-flex justify-content-center align-items-center mt-4"
                                                                    data-toggle="tooltip"
                                                                >
                                                                    <label>
                                                                        <input
                                                                            name="RETIRAR_JUROS"
                                                                            type="checkbox"
                                                                            ref={form.register()}
                                                                        />
                                                                        <span></span>
                                                                    </label>
                                                                </span>
                                                            </div>
                                                            <div className="">
                                                                <div className="d-flex align-items-center justify-content-center">
                                                                    <span>
                                                                        Retirar
                                                                        Multas
                                                                    </span>
                                                                </div>
                                                                <span
                                                                    className="switch switch-outline switch-sm switch-icon switch-success d-flex justify-content-center align-items-center mt-4"
                                                                    data-toggle="tooltip"
                                                                >
                                                                    <label>
                                                                        <input
                                                                            name="RETIRAR_MULTAS"
                                                                            type="checkbox"
                                                                            ref={form.register()}
                                                                        />
                                                                        <span></span>
                                                                    </label>
                                                                </span>
                                                            </div>
                                                        </div>
                                                    ) : (
                                                        <></>
                                                    )}
                                                </div>
                                            </form>
                                        )}

                                        <IndicadoresGerarBoleto
                                            lstParcelas={lstParcelasBoletos}
                                            lstParcelasMarcadas={
                                                lstParcelasBoletosHonorarioRequest
                                            }
                                            descontos={
                                                desconto.JUROS +
                                                desconto.MULTA +
                                                descontoBruto
                                            }
                                            honorario={honorario}
                                        />

                                        {Config.ConfigCobrancaDTO
                                            .FL_ALCADAS_DESCONTO && (
                                            <DescontoAlcada
                                                ID_CASO={props.ID_CASO}
                                                ID_CONTA={props.ID_CONTA}
                                                lstParcelasBoletosRequest={
                                                    lstParcelasBoletosHonorarioRequest
                                                }
                                                setDesconto={setDesconto}
                                                desconto={desconto}
                                                setPorcentagemJuros={
                                                    setPorcentagemJuros
                                                }
                                                setPorcentagemMulta={
                                                    setPorcentagemMulta
                                                }
                                                bloqueioDescontoAlcada={
                                                    bloqueioDescontoAlcada
                                                }
                                                setBloqueioHonorario={
                                                    setBloqueioHonorario
                                                }
                                                porcentagemHonorario={
                                                    porcentagemHonorario
                                                }
                                                porcentagemJuros={
                                                    porcentagemJuros
                                                }
                                                porcentagemHonorarioSaved={
                                                    porcentagemHonorarioSaved
                                                }
                                                porcentagemMulta={
                                                    porcentagemMulta
                                                }
                                            />
                                        )}
                                    </>
                                )}
                                <DescontoHonorarios
                                    ID_CONTA={props.ID_CONTA}
                                    ID_CASO={props.ID_CASO}
                                    setPorcentagemHonorario={
                                        setPorcentagemHonorario
                                    }
                                    setHonorario={setHonorario}
                                    bloqueioHonorario={bloqueioHonorario}
                                    setBloqueioDescontoAlcada={
                                        setBloqueioDescontoAlcada
                                    }
                                    porcentagemHonorarioSaved={
                                        porcentagemHonorarioSaved
                                    }
                                    porcentagemHonorario={porcentagemHonorario}
                                    setBloqueioHonorario={setBloqueioHonorario}
                                    lstParcelasBoletosRequest={
                                        lstParcelasBoletosHonorarioRequest
                                    }
                                    setPorcentagemJuros={setPorcentagemJuros}
                                    porcentagemJuros={porcentagemJuros}
                                    setPorcentagemMulta={setPorcentagemMulta}
                                    porcentagemMulta={porcentagemMulta}
                                />
                                {lstParcelasBoletos.map((parcelas) => {
                                    return (
                                        parcelas.Boleto?.BoletoBase64 && (
                                            <>
                                                <div
                                                    id="accordion"
                                                    className="d-flex flex-wrap container-fluid justify-content-center flex-column align-items-center row col-12 mt-5 "
                                                >
                                                    <div className="card card-header border-1 border-dark bottom-0 left-0 inline-block w-50 p-1 col">
                                                        <div id="headingpix">
                                                            <h5 className="mb-0">
                                                                <button
                                                                    className="d-flex justify-content-center align-items-center container-md btn btn-light w-100 col"
                                                                    data-toggle="collapse"
                                                                    aria-expanded="true"
                                                                    data-target={`#collapsepix${parcelas.Boleto.ID_PARCELA}`}
                                                                    aria-controls="collapsepix"
                                                                >
                                                                    <div className="d-flex flex-column m-1">
                                                                        <h2 className="d-flex justify-content-center align-items-center p-0 m-0 w-100">
                                                                            BOLETO
                                                                            PIX
                                                                            <br />
                                                                            <FontAwesomeIcon
                                                                                icon={
                                                                                    faArrowCircleDown
                                                                                }
                                                                                className="ml-1 mr-1"
                                                                            />
                                                                        </h2>
                                                                        {
                                                                            parcelas.Tipo_Prc
                                                                        }
                                                                        -
                                                                        {
                                                                            parcelas.NumParc_Prc
                                                                        }
                                                                    </div>
                                                                </button>
                                                            </h5>
                                                        </div>
                                                    </div>
                                                    <div
                                                        id={`collapsepix${parcelas.Boleto.ID_PARCELA}`}
                                                        aria-labelledby="headingpix"
                                                        data-parent="#accordion"
                                                        className="panel-collapse collapse mt-4"
                                                        style={{
                                                            width: 350,
                                                            height: 350,
                                                        }}
                                                    >
                                                        <div className="d-flex card justify-content-center align-items-center border-1 border-dark flex-wrap absolute col">
                                                            <span className="text-wrap text-break font-weight-bold align-items-center justify-content-center">
                                                                <br />
                                                                <div className="d-flex align-items-center justify-content-center">
                                                                    <strong>
                                                                        Pix
                                                                        copia e
                                                                        cola:
                                                                        <hr />{" "}
                                                                    </strong>
                                                                    <br />
                                                                </div>
                                                                {
                                                                    parcelas
                                                                        .Boleto
                                                                        .PixCopiaCola
                                                                }
                                                            </span>
                                                            <img
                                                                src={
                                                                    parcelas
                                                                        .Boleto
                                                                        .BoletoBase64
                                                                }
                                                                style={{
                                                                    width: 200,
                                                                    height: 200,
                                                                }}
                                                                alt="Boleto pix!!"
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </>
                                        )
                                    );
                                })}
                                <TableParcelasBoletos
                                    DT_CALCULO={parcelasReq.DT_CALCULO}
                                    empreendimento={props.empreendimento}
                                    loading={tableLoading}
                                    lstParcelas={lstParcelasBoletos}
                                    lstParcelasMarcadas={
                                        lstParcelasBoletosHonorarioRequest
                                    }
                                    unidade={props.unidade}
                                    setLstParcelasMarcadas={
                                        setLstParcelasBoletosRequest
                                    }
                                    showResiduo={showResiduo}
                                    erp={props.parcelasRequest}
                                    //setBoletoParaEmail={}
                                />
                                <div className="w-100 g-4 d-flex justify-content-end">
                                    <BaixarBoletosSelecioados
                                        lstParcelasBoletos={
                                            lstParcelasBoletosHonorarioRequest
                                        }
                                        bloquearBaixarBoleto={
                                            bloquearBaixarBoleto
                                        }
                                        ID_CONTA={props.ID_CONTA ?? 0}
                                    />
                                </div>
                            </FormProvider>
                        </div>
                    ) : (
                        <SpinnerUAU />
                    )}
                </div>
            </Modal.Body>

            <Modal.Footer>
                {!siengeMode && !informakonMode && (
                    <div className="w-100">
                        {alertText && (
                            <div
                                className="alert alert-custom alert-light-success fade show mb-5 w-100"
                                role="alert"
                            >
                                <div className="alert-icon text-success">
                                    <FontAwesomeIcon icon={faCheck} size="2x" />
                                </div>
                                <div className="alert-text">{alertText}</div>
                                <div className="alert-close">
                                    <button
                                        type="button"
                                        className="close"
                                        data-dismiss="alert"
                                        aria-label="Close"
                                        onClick={() => {
                                            setAlertText("");
                                        }}
                                    >
                                        <span aria-hidden="true">
                                            <i className="ki ki-close"></i>
                                        </span>
                                    </button>
                                </div>
                            </div>
                        )}
                        <div className="d-flex flex-wrap justify-content-end p-0">
                            {totvsMode ? (
                                <button
                                    id="GERAR_BOLETO_FORM_SUBMIT"
                                    type="submit"
                                    form="formGerarBoletos"
                                    disabled={gerandoPix || gerando}
                                    className="btn btn-sm btn-shadow btn-primary m-1 toClick"
                                    name="gerarPix"
                                >
                                    {gerandoPix ? (
                                        <div className="d-flex align-items-center g-2">
                                            <div
                                                className="spinner-border spinner-border-sm text-white"
                                                role="status"
                                            >
                                                <span className="sr-only">
                                                    Carregando...
                                                </span>
                                            </div>{" "}
                                            Gerando boleto pix
                                        </div>
                                    ) : (
                                        <div>Gerar Boleto Pix</div>
                                    )}
                                </button>
                            ) : null}

                            {!eSolutionMode && (
                                <button
                                    id="GERAR_BOLETO_FORM_SUBMIT"
                                    type="submit"
                                    form="formGerarBoletos"
                                    disabled={gerando || gerandoPix}
                                    className="btn btn-sm btn-shadow btn-primary m-1 toClick"
                                >
                                    {gerando ? (
                                        <div className="d-flex align-items-center g-2">
                                            <div
                                                className="spinner-border spinner-border-sm text-white"
                                                role="status"
                                            >
                                                <span className="sr-only">
                                                    Carregando...
                                                </span>
                                            </div>{" "}
                                            Gerando Boleto
                                        </div>
                                    ) : (
                                        <div>
                                            <FontAwesomeIcon
                                                icon={faBarcode}
                                                className="mr-2"
                                            />{" "}
                                            Gerar Boleto
                                        </div>
                                    )}
                                </button>
                            )}
                        </div>
                    </div>
                )}
            </Modal.Footer>
        </>
    );
}
